import "../../utils/tailwind.css";
import { PageProvider, useDocumentProvider } from "./provider";

import Section from "../../components/section";
import Button from "../../components/Buttons";
import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import FileUpload from "../../components/file-upload";
import { FormikInput } from "../../components/input";

import { Formik, Form, FieldArray } from "formik";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const {
    handleSubmit,
    initialValues,
    // handleDocumentDelete,
    docuemntArray,
    handleDocumentAdd,
  } = useDocumentProvider();

  return (
    <Section className="h-[80vh] overflow-y-auto">
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize>
        {({ values }) => (
          <Form>
            <div className="flex justify-end" onClick={handleDocumentAdd}>
              <div className="bg-[black] p-1 rounded-full w-auto cursor-pointer">
                <Plus className="text-[white]" />
              </div>
            </div>
            {/* <div className="mt-3 overflow-x-auto mb-10">
              <table className="w-full border-collapse border border-gray-300">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[40%]">
                      Title
                    </th>
                    <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[40%]">
                      Files
                    </th>

                    <th className="border font-normal border-gray-300 text-left w-[10%] px-4">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <FieldArray
                    name="document.documentList"
                    render={(arrayHelper) => {
                      docuemntArray.current = arrayHelper;
                      return (
                        <>
                          {values?.document?.documentList?.map(
                            (item, index) => (
                              <tr key={index}>
                                <td className="border border-gray-300 px-2 py-2 w-[40%]">
                                  <FormikInput
                                    name={`document.documentList.${index}.title`}
                                    rootClassName="w-full"
                                  />
                                </td>

                                <td className="border border-gray-300 px-2 py-2 w-[40%]">
                                  <FileUpload className="w-full" />
                                </td>

                                {values?.document?.documentList?.length > 0 && (
                                  <td className="border border-gray-300 bg-white text-center py-2 w-[10%]">
                                    <Trash
                                      className="cursor-pointer mx-auto "
                                      onClick={handleDocumentDelete(index)}
                                    />
                                  </td>
                                )}
                              </tr>
                            )
                          )}
                        </>
                      );
                    }}
                  />
                </tbody>
              </table>
            </div> */}

<div className="mt-3 overflow-x-auto mb-10">
  <table className="w-full border-collapse border border-gray-300">
    {/* Table Header - Remains Constant */}
    <thead className="bg-gray-200">
      <tr>
        <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[40%]">
          Title
        </th>
        <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[40%]">
          Files
        </th>
        <th className="border font-normal border-gray-300 text-left w-[10%] px-4">
          Action
        </th>
      </tr>
    </thead>

    {/* Table Body - Dynamic Rows */}
    <tbody>
      <FieldArray
        name="document.documentList"
        render={(arrayHelper) => {
          docuemntArray.current = arrayHelper;
          return (
            <>
              {values?.document?.documentList?.map((item, index) => (
                <tr key={index}>
                  {/* Title Input */}
                  <td className="border border-gray-300 px-2 py-2 w-[40%]">
                    <FormikInput
                      name={`document.documentList.${index}.title`}
                      rootClassName="w-full"
                    />
                  </td>

                  {/* File Upload */}
                  <td className="border border-gray-300 px-2 py-2 w-[40%]">
                    <FileUpload className="w-full" />
                  </td>

                  {/* Delete Button */}
                  <td className="border border-gray-300 bg-white text-center py-2 w-[10%]">
                    <Trash
                      className="cursor-pointer mx-auto"
                      onClick={() => arrayHelper.remove(index)} // Corrected function call
                    />
                  </td>
                </tr>
              ))}
            </>
          );
        }}
      />
    </tbody>
  </table>
</div>

            <div className="absolute bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 space-x-3 shadow-md">
              <Button type="submit">Save</Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
